import { Box, Button, Grid, Typography } from "@mui/material";
import { useState } from "react";
import authService from "../Auth/AuthService";

const FileUploadView = ({ fileType, onSuccess }) => {
    const [previewUrl, setPreviewUrl] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const token = authService.tokenInfo();

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const originalName = file.name;
            const extension = originalName.substring(originalName.lastIndexOf('.'));
            const newName = `logo_${token?.mas_id}${extension}`;
            const renamedFile = new File([file], newName, {
                type: file.type,
                lastModified: file.lastModified,
            });

            setSelectedFile(renamedFile);

            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async () => {

        if (!selectedFile) {
            alert("No file selected");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        const dir = [token?.mas_id, fileType].filter(Boolean).join('/');
        formData.append('dir', dir);
        try {
            const url = authService.pathUrl('POST', '/files/upload')
            const res = await authService.restPostFormData(url, formData)
            console.log('Upload success:', res)
            if (onSuccess) onSuccess(res);
        } catch (err) { console.error('Upload error:', err) };
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Box>
                        <Typography variant="h6" mb={2}>Upload and Preview Image</Typography>

                        <Button variant="contained" component="label"
                            sx={{
                                borderRadius: 6,
                                backgroundColor: '#1b1914',
                                '&:hover': {
                                    backgroundColor: '#332a14ff',
                                },
                            }}>
                            Upload Image
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </Button>

                        {previewUrl && (
                            <Box mt={2}>
                                <Typography variant="subtitle2" mb={1}>Image Preview:</Typography>
                                <img
                                    src={previewUrl}
                                    alt="Selected"
                                    style={{ maxWidth: '300px', borderRadius: '8px' }}
                                />
                            </Box>
                        )}
                    </Box>
                </Grid>

                <Box display="flex" justifyContent="flex-end">
                    {selectedFile && (
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                mt: 4,
                                width: '40%',
                                py: 1,
                                borderRadius: 6,
                                backgroundColor: '#1b1914',
                                '&:hover': {
                                    backgroundColor: '#332a14ff',
                                },
                            }}
                        >
                            upload
                        </Button>
                    )}
                </Box>
            </form>
        </>
    );
};

export default FileUploadView;
